var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobApplicationIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99.786,
    height: 88.854,
    viewBox: "0 0 99.786 88.854",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "job_application_icon4",
    transform: "translate(-1657.5 -4652.575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_172487",
    "data-name": "\\uADF8\\uB8F9 172487",
    transform: "translate(1757.286 4671.27) rotate(104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121619",
    "data-name": "\\uD328\\uC2A4 121619",
    d: "M37.4,77.276C29.514,68.039,0,48.889,0,48.889S26.36,35.146,28.388,0c24.106,11.039,42.13,21.854,42.13,21.854S72.095,49.114,37.4,77.276Z",
    transform: "translate(0 0)",
    fill: "#d7e0ec",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121620",
    "data-name": "\\uD328\\uC2A4 121620",
    d: "M37.4,77.277C29.514,68.04,0,48.89,0,48.89S26.36,35.146,28.388,0c24.107,11.04,42.13,21.854,42.13,21.854S72.1,49.115,37.4,77.277Z",
    transform: "translate(3.547 7.095)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121621",
    "data-name": "\\uD328\\uC2A4 121621",
    d: "M26.874,20.471q-6.816-4.911-13.6-9.871C11.041,8.965,8.82,7.307,6.594,5.656A65.678,65.678,0,0,1,.1.581.344.344,0,0,1,.518.043,65.99,65.99,0,0,1,7.367,4.7c2.249,1.613,4.5,3.222,6.739,4.852q6.717,4.893,13.4,9.832C28.148,19.861,27.534,20.947,26.874,20.471Z",
    transform: "translate(16.149 53.872)",
    fill: "#d7e0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121622",
    "data-name": "\\uD328\\uC2A4 121622",
    d: "M26.9,18.853c-4.569-2.976-9.086-6.039-13.614-9.076-2.24-1.5-4.467-3.022-6.7-4.534C5.441,4.469,4.291,3.706,3.159,2.915A18.141,18.141,0,0,1,.084.571C-.122.346.076-.1.4.02A17.917,17.917,0,0,1,3.728,1.942c1.162.742,2.305,1.513,3.456,2.273,2.249,1.485,4.5,2.961,6.746,4.456,4.538,3.024,9.1,6.029,13.592,9.114C28.173,18.23,27.571,19.292,26.9,18.853Z",
    transform: "translate(20.679 49.035)",
    fill: "#d7e0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121623",
    "data-name": "\\uD328\\uC2A4 121623",
    d: "M27.477,18.8Q20.5,14.29,13.55,9.748,10.069,7.481,6.6,5.2C5.5,4.47,4.388,3.748,3.294,3.006A16.637,16.637,0,0,1,.077.514c-.186-.21-.01-.6.29-.5a15.65,15.65,0,0,1,3.4,1.814c1.174.734,2.334,1.488,3.5,2.239q3.488,2.254,6.967,4.522,6.956,4.541,13.907,9.09C28.829,18.138,28.183,19.26,27.477,18.8Z",
    transform: "translate(25.31 43.436)",
    fill: "#d7e0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121624",
    "data-name": "\\uD328\\uC2A4 121624",
    d: "M30.553,16.531c-.262-.05-.513.074-.768.008a4.466,4.466,0,0,1-.825-.415q-1-.524-2.009-1.049-1.921-1.012-3.84-2.028L15.264,8.9q-3.84-2.028-7.671-4.072C5.071,3.477,2.265,2.247.071.387-.108.235.084-.049.291.007,3.017.753,5.573,2.35,8.067,3.644q3.94,2.044,7.861,4.123l7.684,4.05q2,1.056,4.009,2.113c.668.353,1.333.71,2,1.065a3.487,3.487,0,0,1,.732.406c.209.2.259.458.469.668A.278.278,0,0,1,30.553,16.531Z",
    transform: "translate(28.034 37.587)",
    fill: "#d7e0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121625",
    "data-name": "\\uD328\\uC2A4 121625",
    d: "M28.228,15.942c-4.807-2.433-9.512-5.093-14.26-7.64Q10.487,6.434,7.013,4.554A45.755,45.755,0,0,1,.1.564C-.158.356.125-.083.423.014a44.576,44.576,0,0,1,7,3.473q3.569,1.9,7.138,3.807c4.749,2.544,9.569,4.991,14.256,7.648C29.465,15.312,28.889,16.277,28.228,15.942Z",
    transform: "translate(34.108 30.238)",
    fill: "#d7e0ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_121626",
    "data-name": "\\uD328\\uC2A4 121626",
    d: "M27.728,15.587q-7.037-3.748-14.07-7.5C11.371,6.858,9.076,5.646,6.8,4.406,5.632,3.771,4.459,3.145,3.3,2.491A14.1,14.1,0,0,1,.069.391.233.233,0,0,1,.294,0a13.765,13.765,0,0,1,3.4,1.443c1.192.589,2.366,1.215,3.547,1.827C9.6,4.5,11.943,5.754,14.293,7q7.049,3.728,14.086,7.475C29.113,14.862,28.462,15.977,27.728,15.587Z",
    transform: "translate(38.296 21.662)",
    fill: "#d7e0ec"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobApplicationIcon4);
export default __webpack_public_path__ + "static/media/job_application_icon4.aef4fb4cdce1009a483c5bcc2baaee8d.svg";
export { ForwardRef as ReactComponent };